import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import {
  Card,
  Button,
  Input,
  Table,
  Select,
  Dropdown,
  Icon,
  Modal,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import EditingLine from "./EditingLine"
import { apiDelete } from "../utils/apiConnector"
import { storeApi } from "../config/apiUrls"

const LineInner = (props) => {
  const { t } = useTranslation()
  const { line, getLines, setModal, products } = props
  const [edit, setEdit] = useState(false)
  const [name, setName] = useState(line.name)
  const [ident, setIdent] = useState(line.ident)
  const [serial, setSerial] = useState(line.serial)
  const [product, setProduct] = useState(
    products.filter((q) => q.name === line.productName).length > 0
      ? products.filter((q) => q.name === line.productName)[0].id
      : "",
  )
  useEffect(() => {
    return () => {}
  }, [])
  return (
    <>
      <div>
        <Card fluid>
          <Card.Content>
            {edit ? (
              <>
                <EditingLine
                  line={line}
                  name={name}
                  setName={setName}
                  ident={ident}
                  setIdent={setIdent}
                  product={product}
                  setProduct={setProduct}
                  serial={serial}
                  setSerial={setSerial}
                  getLines={getLines}
                  setModal={setModal}
                />
              </>
            ) : (
              <>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <h3 style={{ marginRight: 10 }}>
                      <b>{t("Device")}</b>
                    </h3>
                    <Icon
                      name="edit"
                      size="big"
                      onClick={() => {
                        setEdit(!edit)
                      }}
                    />
                    <Icon
                      name="trash"
                      size="big"
                      onClick={() => {
                        apiDelete(storeApi + "/" + line.id)
                          .onOk((res) => {
                            console.log(res)
                            getLines()
                          })
                          .onFail(() => {})
                          .afterAll(() => {
                            setModal(false)
                          })
                          .startSingle()
                      }}
                    />
                  </div>
                  <div>
                    <Table fluid style={{ border: "0px solid red" }}>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Name")}</b>
                          </Table.Cell>
                          <Table.Cell>{line.name}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Идентификатор</b>
                          </Table.Cell>
                          <Table.Cell>{line.ident}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>
                            <b>{t("Product name")}</b>
                          </Table.Cell>
                          <Table.Cell>{line.productName}</Table.Cell>
                        </Table.Row>
                        <Table.Row style={{ display: "none" }}>
                          <Table.Cell>
                            <b>Серия</b>
                          </Table.Cell>
                          <Table.Cell>{line.serial}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </div>
                </div>
              </>
            )}
          </Card.Content>
        </Card>
      </div>
    </>
  )
}

export default LineInner
